<template>
  <v-toolbar
    id="core-toolbar"
    flat
    prominent
    :style="(!exibeLogo) ? 'background: rgba(0, 0, 0, 0); position: fixed; z-index: 100;' : 'background: rgba(0, 0, 0, 0); position: relative; z-index: 100;'"
  >
    <div/>
    <a
      v-if="exibeLogo"
      href="/">
      <img
        :src="logo"
        style="z-index: 150"
        width="70px"
      >
    </a>

    <v-spacer />
    <v-toolbar-items>
      <v-flex
        align-center
        layout
        py-2
      >
        <v-flex>
          <v-flex>
            <v-btn
              :title="'Suporte'"
              icon
              text
              @click="suporte"
            >
              <v-icon color="white">mdi-whatsapp</v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
        <template v-if="exibeLivrosFree">
          <v-menu
            open-on-hover
            bottom
            left
            content-class="dropdown-menu"
            offset-y
            transition="slide-y-transition">
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                text
                dark
                v-on="on"
              >
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-list dense>
                <v-list-tile
                  v-for="planilha in menus.planilhas"
                  :key="planilha.title[idioma]"
                  :href="'assets/planilhas/'+planilha.action"
                  :target="planilha.nova_aba ? '_blank': null"
                >
                  <v-list-tile-title
                    v-text="planilha.title[idioma]"
                  />
                </v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
          <v-menu
            open-on-hover
            bottom
            left
            content-class="dropdown-menu"
            offset-y
            transition="slide-y-transition">
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                text
                dark
                v-on="on"
              >
                <v-icon>mdi-notebook</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-list dense>
                <v-list-tile
                  v-for="livro in menus.livros"
                  :key="livro.title[idioma]"
                  :href="livro.action"
                  :target="livro.nova_aba ? '_blank': null"
                >
                  <v-list-tile-title
                    v-text="livro.title[idioma]"
                  />
                </v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
        </template>
        <v-menu
          open-on-hover
          bottom
          left
          content-class="dropdown-menu"
          offset-y
          transition="slide-y-transition">
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              text
              dark
              v-on="on"
            >
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list dense>
              <v-list-tile
                v-for="instrucao in menus.instrucoes"
                :key="instrucao.title[idioma]"
                :href="instrucao.action"
                target="_blank"
              >
                <v-list-tile-title
                  v-text="instrucao.title[idioma]"
                />
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
        <v-menu
          :close-on-content-click="false"
          :nudge-width="250"
          :nudge-height="250"
          open-delay="900"
          bottom
          right
          offset-y
          transition="slide-y-transition"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              text
              small
              v-on="on"
            >
              <v-icon :color="idioma === 0  ? 'green': (idioma === 2) ? 'yellow' : 'red'">mdi-flag</v-icon>
              <template v-if="(idioma === 0)">
                <small
                    v-if="idioma === 0"
                    style="font-weight: bold; padding: 0 2px; background: grey; opacity: 0.9; font-size:9px;">PT-BR</small>
              </template>
              <template v-else-if="(idioma === 1)">
                <small
                    v-if="(idioma === 1)"
                    style="font-weight: bold; padding: 0 2px; background: grey; opacity: 0.9; font-size:9px;">EN</small>
              </template>
              <template v-else-if="(idioma === 2)">
                <small
                    v-if="(idioma === 2)"
                    style="font-weight: bold; padding: 0 2px; background: grey; opacity: 0.9; font-size:9px;">ES</small>
              </template>
            </v-btn>
          </template>
          <v-card max-height="100px" style="padding: 10px;">
            <v-layout wrap flex justify-space-around>
              <v-card :style="idioma === 0 ? 'background-color: blue; padding: 3px; margin: 3px;' : 'padding: 3px;'">
                <v-btn
                  text
                  flat
                  xs4
                  dark
                  small
                  icon
                  
                  title="PT-BR">
                  <v-img
                    src="./img/brasil.png"
                    style="height: 40px!important; width: 50px!important; opacity: 0.7"
                    contain
                    icon
                    @click="setIdioma(0)"
                  >
                    <small
                      v-if="idioma !== 0"
                      style="font-weight: bold; padding: 0 2px; background: grey; opacity: 0.7; font-size:9px; ">PT-BR</small>
                  </v-img>

                </v-btn>
              </v-card>
              <v-card :style="idioma === 1 ? 'background-color: blue; padding: 3px; margin: 3px;' : 'padding: 3px;'">
                <v-btn
                  text
                  dark
                  xs4
                  flat
                  small
                  icon
                  
                  title="EN-US">
                  <v-img
                    src="./img/en.png"
                    style="height: 40px!important; width: 50px!important; opacity: 0.7"
                    contain
                    icon
                    @click="setIdioma(1)"
                  >
                    <small
                      v-if="idioma !== 1"
                      style="font-weight: bold; padding: 0 2px; background: grey; opacity: 0.7; font-size:9px; ">ENGLISH</small>
                  </v-img>
                </v-btn>
              </v-card>
              <v-card :style="idioma === 2 ? 'background-color: blue; padding: 3px; margin: 3px;' : 'padding: 3px;'">
                <v-btn
                  text
                  dark
                  xs4
                  small
                  icon
                  
                  title="ES">
                  <v-img
                    src="./img/es.png"
                    style="height: 40px!important; width: 50px!important; opacity: 0.7"
                    contain
                    icon
                    @click="setIdioma(2)"
                  >
                    <small
                      v-if="idioma !== 2"
                      style="font-weight: bold; padding: 0 2px; background: grey; opacity: 0.7; font-size:9px; ">ESPAÑOL</small>
                  </v-img>
                </v-btn>
              </v-card>
            </v-layout>
          </v-card>
        </v-menu>
        <v-btn
          icon
          text
          small
          @click="toggleDark()"
        >
          <v-icon>mdi-theme-light-dark</v-icon>
        </v-btn>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>

import {
  mapState,
  mapMutations
} from 'vuex'

export default {
  data: () => ({
    title: null,
    responsive: false,
    responsiveInput: false,
    logo: process.env.VUE_APP_LOGO_BRANCA ? process.env.VUE_APP_LOGO_BRANCA : 'img/brcorte5-logobranca.png',
    exibeLivrosFree: false
  }),
  computed: {
    ...mapState('app', ['menus', 'idioma', 'exibeLoja']),
    exibeLogo () {
      return this.$route && this.$route.path !== '/login' && this.$route.path !== '/signin'
    }
  },
  watch: {
    '$route' (val) {
      this.title = val.name
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
    
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer', 'toggleDark']),
    suporte () {
      let title = 'Suporte'
      let msg = '<h3>Entre em contato:</h3><a href="https://api.whatsapp.com/send?phone=5537999820856&text=Olá, vocês podem me ajudar?">Whatsapp: (37) 99982-0856</a> (Segunda a Sexta - 08 às 18 hrs*) *Horário de Brasília<br><a href="mailto:contato@brcorte.com.br">E-Mail: contato@brcorte.com.br</a>'
      this.$store.commit('openOKModal', { title, msg })
    },
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick () {
      //
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    },
    setIdioma (idioma) {
      this.$store.commit('setIdioma', idioma)
      this.title = this.$route.name[idioma]
      this.$vuetify.lang.current = idioma ? 'en' : 'pt'
    }
  }
}
</script>

<style>
  #core-toolbar {
    -webkit-filter: blur(0px);
    -moz-filter: blur(0px);
    -o-filter: blur(0px);
    -ms-filter: blur(13px);
    filter: blur(0px);

    -webkit-backdrop-filter: blur(1px); /* Safari 9+ */
    backdrop-filter: blur(1px); /* Chrome and Opera */
  }
  #core-toolbar a {
    text-decoration: none;
  }
  ul li {
    list-style: none;
  }
</style>
